module.exports = __webpack_public_path__ + "static/media/clock-time.40cbba25.gif";